module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.1917/img/hubspot-tools-logo.png"